import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserActivityInfoModel } from '../model';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { htmlUrls } from '@shared/utils/router-paths';
import { TextClickablePipe, UserImageIconPipe, UserImagePipe } from '../pipes';
import { FeedLinksPipe } from '@shared/components/Feeds/pipes/feed-links/feed-links.pipe';
import { JalaliDateComponent } from '@shared/components/jalali-date/jalali-date.component';
import { userNameID } from '@shared/model/comment-aggrigator-model';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { UserTypeEnum } from '@shared/model/enum/user-type-enum';

@Component({
  selector: 'app-user-activity-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    ImagePipe,
    FeedLinksPipe,
    UserImagePipe,
    JalaliDateComponent,
    UserImageIconPipe,
    TextClickablePipe,
  ],
  templateUrl: './user-activity-info.component.html',
  styleUrls: ['./user-activity-info.component.scss']
})
export class UserActivityInfoComponent {
  @Input() User!: UserActivityInfoModel;
  @Input() replyUser!: userNameID;
  @Input() inside!: boolean;
  @Input() displayReply = false;
  @Input() isComment = false;
  @Input() isNotification = false;
  @Input() isClubCourseItem = false;
  @Input() isClubAdminsActivity = false;
  @Input() notificationBadge = false;
  @Input() reviewSlider = false;
  @Input() displayDate = true;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() textSize = "text-base";
  @Input() commentId!: string

  @Output() otherPoeples: EventEmitter<any> = new EventEmitter<any>()

  routes = htmlUrls;

  imageType = EImageType;
  userTypeEnum = UserTypeEnum;


  otherPeopleClicked() {
    const objId: string = this.User.activityVerb === ActivityVerbEnum.Reacted ? this.User.reactedId! : this.User.activityObjectId!;
    this.otherPoeples.emit({ objectId: objId, isReacted: this.User.activityVerb === ActivityVerbEnum.Reacted });
  }
}
